export const copernicusAttribution = "© Contains Modified Copernicus Sentinel Data";
export const ororatechAttribution = "© OroraTech";
export const osmAttribution = "© OpenStreetMap Contributors";
export const wofAttribution = "© Who's On First, Natural Earth";
export const dwdAttribution = "© DWD";
export const cartoAttribution = "© CARTO";
export const blitzortungAttribution = "© Blitzortung.org";
export const cyclosmAttribution = "© CyclOSM";
export const imprintAttribution = "| <a href=\"/imprint.html\">Imprint</a>";
